module.exports = __webpack_public_path__ + "static/img/Bachelor_010583.7210692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010583.jpg
// module id = 193
// module chunks = 0